export default function () {
    function AddLogEntry(response) {

        console.log(response);

        const modalProgressBar = document.getElementById('modal-progress-bar');
        modalProgressBar.value = modalProgressBar.value + 1;

        document.querySelector(`#${response.ContainerId}`).innerHTML =
            `<li class="text-with-icon ${response.Success ? 'normal icon-ok' : 'warning icon-attention-alt'}">
                    [ID: ${response.ProductId}] ${response.Message}
             </li>`;


    }

    function InitLogEntry(id) {
        const ident = `entry-container-${id}`;

        document.getElementById(`modal-result-box`).insertAdjacentHTML(
            'afterbegin',
            `<li class="text-with-icon" id="${ident}">
                <div class="animated rotateIn infinite">
                    <i class="icon-spin1" ></i>
                </div>
                oczekuję ...
             </li>`
        );
        return ident;
    }

    const modalBeingAction = document.getElementById('modal-begin-action');


    function ParseValue(valueItem) {

        if (!valueItem) return null;

        if (valueItem.type === 'checkbox') {

            return valueItem.checked;
        }
        else if (valueItem.type === 'select-multiple') {
            console.log("Found multi Item", valueItem.selectedOptions);
            return Array.from(valueItem.selectedOptions).map(function (item) { return item.value; }).join(",");
        }
        else {
            return valueItem.value || ''
        }

    }

    if (!modalBeingAction) return;

    modalBeingAction.addEventListener('click', function () {
        let pid;
        let counter = 1;
        const modalValue = document.getElementById('modal-value');

        const val = ParseValue(modalValue);


        document.getElementById('modal-progress-bar').classList.add('in-progress');

        var mode = document.body.getAttribute('data-massaction-mode');
        var actionRoute = `panel/methods/${mode}Action`;

        const localItems = [...items]; 

        while ((pid = localItems.pop()) !== undefined) {
            let payload = {
                pid,
                action: window.selectedAction,
                value: val
            };

            counter++;
            payload.containerId = InitLogEntry(counter);

            fetch(`/${actionRoute}`, {
                method: 'POST',
                body: JSON.stringify(payload),
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            }).then(response => {
                return response.json();
            }).then(data => {
                AddLogEntry(data);
            }).catch(error => {
                console.log(error);
            });
        }




    });
}